import React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import { Tooltip } from '@vlabs/uikit';
import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './EmptyCard.module.sass';

interface EmptyCardProps extends WithClassNameProp, WithDataTestid {
  text?: string;
  dataTip?: string;
  icon?: React.ReactNode;
}

const displayName = 'EmptyCard';
const testid = buildTestid(displayName);

function EmptyCard({
  text = undefined,
  dataTip = undefined,
  icon = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: EmptyCardProps): React.JSX.Element {
  return (
    <div
      className={cn(st.Root, className)}
      {...testid(dataTestId)}
    >
      {icon}
      <span className={st.Text}>
        {text}

        {!!dataTip && (
          <Tooltip
            className={st.Tooltip}
            tooltipContent={dataTip}
            tooltipProps={{ effect: 'solid' }}
          >
            <InfoCircleIcon className={st.Tooltip_icon} />
          </Tooltip>
        )}
      </span>
    </div>
  );
}

export { EmptyCard };
